import React, { FC } from 'react';
import cn from 'classnames';
import { ITextInputSizes } from '../TextInput';
require("./TextInput-Label.css");
var styles = {
  "Root": "TextInput-Label-module-Root_M1Y",
  "Required": "TextInput-Label-module-Required_2Bt",
  "dependent": "TextInput-Label-module-dependent_1fF",
  "sSize": "TextInput-Label-module-sSize_2Yj",
  "mSize": "TextInput-Label-module-mSize_1mN",
  "lSize": "TextInput-Label-module-lSize_gEt"
};
export const TextInputLabel = ({
  text,
  dependent,
  size,
  inputId,
  required,
  className
}) => /*#__PURE__*/React.createElement("label", {
  className: cn(styles.Root, styles[`${size}Size`], {
    [styles.dependent]: dependent
  }, className),
  htmlFor: inputId
}, text, required && /*#__PURE__*/React.createElement("sup", {
  className: styles.Required
}, "\u2731"));